import MachineTemplateIcon from "@shared/svg/machine-template-icon.svg?react";
import Tag, { TAG_COLORS } from "@shared/ui/Tag";
import React from "react";
import { useIntl } from "react-intl";

import getEnums from "$/settings/enums";
import TEMPLATE_TYPES from "$/settings/enums/machineTemplate/index.json";

const templateTypes = getEnums(TEMPLATE_TYPES, "reference");

export const MachineTemplateLabel = ({
  type,
  showIcon = true,
  showLabel = true,
  label = "",
  iconSize = 14,
  className = "",
}) => {
  const { messages } = useIntl();
  return (
    <Tag
      label={label || messages?.machines?.machineTemplateType[type]}
      className={`truncate max-w-[150px] group ${className}`}
      leadingIcon={
        showIcon ? (
          <div className="flex items-center justify-center">
            <MachineTemplateIcon
              width={iconSize}
              height={iconSize}
              className="text-primary group-hover:text-inverse"
            />
          </div>
        ) : null
      }
      color={
        type === templateTypes.machineTemplate
          ? TAG_COLORS.BLACK
          : TAG_COLORS.MINT
      }
    />
  );
};
